export default {"src":"/_next/static/media/cocktail_white.ed7a94a6.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};